module.exports = __webpack_public_path__ + "static/media/Level3.b5a4d06a.png";